import React from "react";
import { Redirect } from 'react-router-dom';
import { CheckoutProvider } from './../Providers/CheckoutProvider'
import { Routes } from './../Core/Constants';
import { AppStore } from './../Core/AppStore'

export default class CheckoutRepeatPayment extends React.Component {

    constructor(props) {
        super(props);
		this.state = {
			shouldRedirect: false,
			invc: null,
			time: null
		}
	}

	componentDidMount = () => {
		this.state.invc = this.props.invc;
		this.state.time = this.props.time;
		AppStore.emit('Checkout.Header', true);
		this.repeatPayment();
	}

	repeatPayment = () => {
		CheckoutProvider.repeatPayment(this.state.invc, this.state.time)
			.then((data) => {
				if (data.gatewayError) {
					window.alert(data.gatewayError);
				}
				else {
					this.setState({
						shouldRedirect: true
					});
				}
			})
			.fail((err) => {
				window.alert(err);
			});
	}

	render = () => {
		if (this.state.shouldRedirect)
			return <Redirect to={Routes.CheckoutFinish} />;

		return <div className="checkout-page"></div>;
	}
}
